import React, { useEffect, useState, useRef, useMemo } from "react";
import { useHistory, withRouter, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Alert,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  WebUrl,
  ApiUrl,
  ApiKey,
  LanguageOption,
  SessionKey,
  Language,
  AlertTypes,
  DisplayDevice,
  _MAIN_WALLET_ID,
  KEY,
  PhoneNumberPrefix,
  TransactionType,
} from "../../util/Constant";
import ApiEngine from "../../util/ApiEngine.js";
import { createFormBody, createMultiPartFormBody, numberWithCurrencyFormat, stringIsNullOrEmpty, numberWithCurrencyFormat2 } from "../../util/Util.js";
import { setBusy, setIdle, showMessage, showResponseMessage, setBannerPopupImage, setBannerPopupModal } from "../../redux/AppAction.js";
import SuccessModal from "../../components/custom/SuccessModal";

/// <summary>
/// Author: -
/// </summary>
const Congrats = (props) => {
  const _location = useLocation();
  const _history = useHistory();
  const { t, i18n } = useTranslation();
  const _dispatch = useDispatch();
  const [successRegisterModalVisible, setSuccessRegisterModalVisible] = useState(false);
  const [countdownPeriod, setCountdownPeriod] = useState(0);
  const [myTimer, setMyTimer] = useState(null);
  const _COUNTDOWN_PERIOD = 5;
  const _SECONDS_IN_MS = 1000;
  const [TACtimedOut, setTACtimedOut] = useState(true);

  useEffect(() => {
    if (countdownPeriod == 300) {
      clearTimeout(myTimer);
    }
    if (countdownPeriod > 0) {

      let timer = setTimeout(() => {
        let tempPeriod = countdownPeriod - 1;
        setCountdownPeriod(tempPeriod);
      }, _SECONDS_IN_MS);

      //myTimer = timer;    handleLogout();
      setMyTimer(timer);

    } else {
      setTACtimedOut(true);
    }
  }, [countdownPeriod]);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    if (stringIsNullOrEmpty(_location.state)) {
      _dispatch(showResponseMessage(false, t("YOU_ARE_NOT_ALLOW_ACCESS_THIS_PAGE")));
      setTimeout(() => window.location.replace(WebUrl._URL_MAIN), 3000);
    } else
    {
      setSuccessRegisterModalVisible(true);
      setCountdownPeriod(_COUNTDOWN_PERIOD);
      setTimeout(() => window.location.replace(WebUrl._URL_MAIN), 5000);
    }
  }

  return (
    <div id="congrats-page">
      <Modal
        id="congrats-page-modal"
        isOpen={successRegisterModalVisible}
        centered
        contentClassName="custom-success-modal"
        backdrop={true}
        backdropClassName="congrats-page-modalmodel-backdrop"

      >
        <ModalBody>
          <div className="modal-container">
            <div className="img-wrapper">
              <img src="/img/version3/successful.svg" alt="success" />
            </div>

            <div className="text-container">
              <div className="title-wrapper">
                <span>{t("CONGRATULATIONS")}</span>
              </div>

              <div className="description-wrapper">
                <span>{t("ACCOUNT_REGISTER_SUCCESS")}</span>
              </div>
            </div>

            <div className="btn-wrapper" style={{ padding: '10px 0px' }}>
              <button type="button" className="primary-btn" onClick={() =>
              {
                window.location.replace(WebUrl._URL_MAIN);
              }}>{t("GO_TO_HOME")}</button>
              </div>
              <div className="description-wrapper">{countdownPeriod}  {t("SECOND")}</div>
          </div>
        </ModalBody>
      </Modal>
     
    </div>
  );
};

export default Congrats;
